import React from 'react';
import { useTranslation } from 'react-i18next';
import './index.css';

const GlobalMapPlaceholder: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="global-map-container-image">
      <img 
        src="/images/solutions/map.webp" 
        alt={t('solutions.globalFootprint.title')}
        className="global-map-image"
      />
    </div>
  );
};

const Solutions: React.FC = () => {
  const { t } = useTranslation();
  const bannerImagePath = '/images/solutions/banner.webp';
  
  // 成功案例数据
  const successCases = [
    {
      id: 1,
      title: t('solutions.successCases.case1.title'),
      description: t('solutions.successCases.case1.description'),
      image: '/images/solutions/1.webp'
    },
    {
      id: 2,
      title: t('solutions.successCases.case2.title'),
      description: t('solutions.successCases.case2.description'),
      image: '/images/solutions/2.webp'
    },
    {
      id: 3,
      title: t('solutions.successCases.case3.title'),
      description: t('solutions.successCases.case3.description'),
      image: '/images/solutions/3.webp'
    },
    {
      id: 4,
      title: t('solutions.successCases.case4.title'),
      description: t('solutions.successCases.case4.description'),
      image: '/images/solutions/4.webp'
    }
  ];

  // 合作流程数据
  const cooperationSteps = {
    odm: [
      { step: '01', title: t('solutions.cooperation.odmSteps.step1') },
      { step: '02', title: t('solutions.cooperation.odmSteps.step2') },
      { step: '03', title: t('solutions.cooperation.odmSteps.step3') },
      { step: '04', title: t('solutions.cooperation.odmSteps.step4') },
      { step: '05', title: t('solutions.cooperation.odmSteps.step5') },
      { step: '06', title: t('solutions.cooperation.odmSteps.step6') },
      { step: '07', title: t('solutions.cooperation.odmSteps.step7') },
      { step: '08', title: t('solutions.cooperation.odmSteps.step8') }
    ],
    oem: [
      { step: '01', title: t('solutions.cooperation.oemSteps.step1') },
      { step: '02', title: t('solutions.cooperation.oemSteps.step2') },
      { step: '03', title: t('solutions.cooperation.oemSteps.step3') },
      { step: '04', title: t('solutions.cooperation.oemSteps.step4') },
      { step: '05', title: t('solutions.cooperation.oemSteps.step5') },
      { step: '06', title: t('solutions.cooperation.oemSteps.step6') },
      { step: '07', title: t('solutions.cooperation.oemSteps.step7') }
    ]
  };

  return (
    <main className="solutions-container">
      {/* 页面标题区域 */}
      <section className="solutions-hero-section">
        <div 
          className="solutions-hero-background"
          style={{
            backgroundImage: `url('${bannerImagePath}')`
          }}
        >
          <div className="solutions-hero-overlay">
            <div className="solutions-hero-container">
              <h1 className="solutions-hero-title">{t('solutions.title')}</h1>
              <p className="solutions-hero-subtitle">
                {t('solutions.subtitle')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 全球业务足迹 */}
      <section className="global-footprint-section">
        <div className="global-footprint-container">
          <h2 className="section-title">{t('solutions.globalFootprint.title')}</h2>
          <div className="global-map-container">
            <GlobalMapPlaceholder />
          </div>
        </div>
      </section>

      {/* 成功案例展示 */}
      <section className="success-cases-section">
        <div className="success-cases-container">
          <h2 className="section-title">{t('solutions.successCases.displayTitle')}</h2>
          <div className="cases-list">
            {successCases.map((caseItem, index) => (
              <div key={caseItem.id} className={`case-item ${index % 2 === 0 ? 'case-left' : 'case-right'}`}>
                <div className="case-image">
                  <img 
                    src={caseItem.image} 
                    alt={caseItem.title}
                    className="case-image-placeholder"
                    onError={(e) => {
                      // 图片加载失败时的处理
                      e.currentTarget.style.display = 'none';
                      }}
                  />
                </div>

                <div className="case-content">
                  <h3 className="case-title">{caseItem.title}</h3>
                  <p className="case-description">{caseItem.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 合作流程 */}
      <section className="cooperation-flow-section">
        <div className="cooperation-flow-container">
          <h2 className="section-title">{t('solutions.cooperation.title')}</h2>
          
          {/* ODM流程 */}
          <div className="flow-type">
            <h3 className="flow-title">{t('solutions.cooperation.odmTitle')}</h3>
            <div className="process-flow">
              <div className="flow-main-line"></div>
              {cooperationSteps.odm.map((step, index) => (
                <div key={step.step} className="flow-step-container">
                  <div className="flow-point">
                    <span className="flow-number">{step.step}</span>
                  </div>
                  <div className={`flow-vertical-line ${index % 2 === 0 ? 'line-up' : 'line-down'}`}></div>
                  <div className={`flow-label ${index % 2 === 0 ? 'label-up' : 'label-down'}`}>
                    {step.title}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* OEM流程 */}
          <div className="flow-type">
            <h3 className="flow-title">{t('solutions.cooperation.oemTitle')}</h3>
            <div className="process-flow">
              <div className="flow-main-line"></div>
              {cooperationSteps.oem.map((step, index) => (
                <div key={step.step} className="flow-step-container">
                  <div className="flow-point">
                    <span className="flow-number">{step.step}</span>
                  </div>
                  <div className={`flow-vertical-line ${index % 2 === 0 ? 'line-up' : 'line-down'}`}></div>
                  <div className={`flow-label ${index % 2 === 0 ? 'label-up' : 'label-down'}`}>
                    {step.title}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Solutions;
